// removed by extract-text-webpack-plugin
module.exports = {"Plan__details-block-info":"_2M1U5AneDUAvMVaQI6X0gm","PackHeader":"_1RdoEs68TDnjerm1XHDNL3","PackHeader__title":"_34tHTlBWIkDO9pvpBMpyKQ","PackHeader__guts":"_6HvkS2EgcDJrA6YAFm4CG","PackHeader__details":"_16YPVL7TFj7OTVAXgHGHK7","PackHeader__actions":"_3tN10qJS_nhOBEQkNa_nlr","DownloadResolutions":"_3ctkX03KAH5kIoyNUzrmuu","BuyButton":"h3pDn7BSnoO_mHk4QlIED","PackHeaderSwitch":"_3_dHzINxGCEGTRvx9BsNY4","PackHeaderSwitch__button":"_2Gi6PbVyxgZeMuuQKf4c19","PackHeaderSwitch__button--active":"_3i2y-_36nLI5eR28ATKiQz","Pack__price":"_31yDQuj6-irpc0ZBzL0L9M","Pack__comparePrice":"_2GQEDJPduS70CkSY7xqAqa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PackHeader/PackHeader.scss
// module id = 1080
// module chunks = 0